<template>
  <div id="pay_index">
    <dv-full-screen-container class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- 第一行标题装饰条 -->
        <div class="d-flex jc-center">
          <dv-decoration-10
            :color="['#690998', '#690998']"
            style="width: 20%; height: 0.0625rem"
          />
          <div class="d-flex jc-center" style="width: 60%">
            <dv-decoration-8
              :color="['#690998', '#000000']"
              style="width: 20%; height: 0.625rem"
            />
            <div class="title" style="width: 60%">
              <span class="title-text">{{ title }}</span>
              <dv-decoration-5
                class="title-bototm"
                :color="['#690998', '#690998']"
                style="width: 3.8rem; padding-top: 0.18rem"
              />
            </div>
            <dv-decoration-8
              :reverse="true"
              :color="['#690998', '#000000']"
              style="width: 20%; height: 0.625rem"
            />
          </div>
          <dv-decoration-10
            :color="['#690998', '#690998']"
            style="width: 20%; height: 0.0625rem; transform: rotateY(180deg)"
          />
        </div>
        <!-- 第二行 -->
        <div class="d-flex jc-between px-2">
          <div class="d-flex" style="width: 40%">
            <div
              class="react-right ml-4"
              style="width: 5rem; background-color: #2c0c4b"
            >
              <span
                class="react-before"
                style="background-color: #2c0c4b"
              ></span>
              <div
                style="
                  float: left;
                  transform: skewX(-45deg);
                  font-weight: 600;
                  font-size: 0.25rem;
                "
              ></div>
            </div>
            <div
              class="react-right ml-3"
              style="width: 5rem; background-color: #2c0c4b"
            ></div>
          </div>
          <div class="d-flex" style="width: 40%">
            <div
              class="react-left mr-3"
              style="width: 5rem; background-color: #2c0c4b"
            ></div>
            <div
              class="react-left mr-4"
              style="width: 5rem; background-color: #2c0c4b; text-align: right"
            >
              <span
                class="react-after"
                style="background-color: #2c0c4b"
              ></span>
              <span class="text" style="font-size: 0.25rem">{{ date }}</span>
            </div>
          </div>
        </div>
        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box" style="height: 62vh">
            <div>
              <dv-border-box-6
                :color="['#186fb9', '#6d5177']"
                style="height: 50%"
              >
                <topLeft1 />
              </dv-border-box-6>
              <dv-border-box-6
                :reverse="true"
                :color="['#186fb9', '#6d5177']"
                style="height: 50%"
              >
                <topLeft2 />
              </dv-border-box-6>
            </div>
            <div>
              <dv-border-box-1 :color="['#664273', '#0c3f89']">
                <topCenter />
              </dv-border-box-1>
            </div>
            <div>
              <dv-border-box-2 :color="['#6d5177', '#186fb9']">
                <topRight />
              </dv-border-box-2>
            </div>
          </div>
          <!-- 第四行数据 isRouterShow: 是否重新加载组件-->
          <div class="bototm-box" style="height: 32vh">
            <bottom v-if="isRouterShow" />
          </div>
        </div>
      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
var storage = window.localStorage;
var title = storage.getItem("title");
if (title == "false") {
  title = "缴费服务大数据看板";
}
import topLeft1 from "./topLeft1";
import topLeft2 from "./topLeft2";
import topCenter from "./topCenter";
import topRight from "./topRight";
import bottom from "./bottom";
export default {
  name: "index",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      loading: true,
      title: title,
      date: this.dateFormatToString(new Date()),
      isRouterShow: true,
    };
  },
  components: {
    topLeft1,
    topLeft2,
    topCenter,
    topRight,
    bottom,
  },
  mounted() {
    this.cancelLoading();
    this.initData();
    // 定时器刷新 1秒
    let _this = this;
    setInterval(() => {
      _this.date = _this.dateFormatToString(new Date());
    }, 1000);
  },
  methods: {
    //重新加载组件
    reload() {
      this.isRouterShow = false;
      this.$nextTick(function () {
        this.isRouterShow = true;
      });
    },
    //关闭loading加载条
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    initData() {
      this.$http.get("/dataView/getPayIndexInfo").then((res) => {
        console.log(res);
      });
    },
    //日期格式化
    dateFormatToString(data) {
      let formatDateTime;
      let Y = data.getFullYear();
      let M = data.getMonth() + 1;
      let D = data.getDate();
      let H = data.getHours();
      let Min = data.getMinutes();
      let S = data.getSeconds();
      let W = data.getDay();
      H = H < 10 ? "0" + H : H;
      Min = Min < 10 ? "0" + Min : Min;
      S = S < 10 ? "0" + S : S;
      switch (W) {
        case 0:
          W = "天";
          break;
        case 1:
          W = "一";
          break;
        case 2:
          W = "二";
          break;
        case 3:
          W = "三";
          break;
        case 4:
          W = "四";
          break;
        case 5:
          W = "五";
          break;
        case 6:
          W = "六";
          break;
        default:
          break;
      }
      formatDateTime =
        Y + "年" + M + "月" + D + "日 " + H + ":" + Min + ":" + S + " 星期" + W;
      this.date = formatDateTime;
      return formatDateTime;
    },
  },
  // 注意在vue实例销毁前，清除我们的定时器。
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/payIndex.scss";

#pay_index {
  .title {
    line-height: 0.8rem;

    .title-text {
      font-size: 0.45rem !important;
      width: 100%;
      font-weight: 600;
      background-image: linear-gradient(135deg, #00e2ff, #da00ff);
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}
</style>
